import { useSelector } from 'react-redux'
import { UseTranslationOptions, UseTranslationResponse, useTranslation as useI18nTranslation, TFunction } from 'react-i18next'
import isTranslationDebugEnabledSelector from '../redux/selectors/isTranslationDebugEnabledSelector'
import brandSelector from "../redux/selectors/brandSelector"

const useTranslation = (options?: UseTranslationOptions): UseTranslationResponse<'dcc-app'> => {
    const { t: tOriginal, i18n, ready } = useI18nTranslation('dcc-app', {
        ...options,
        useSuspense: false,
    })

    const translationDebugEnabled = useSelector(isTranslationDebugEnabledSelector)
    const brand = useSelector(brandSelector)
    const t: TFunction<'dcc-app'> = (key: string, params?: {}) => {
        const keyWithBrand = key + "_" + brand
        const brandValue = tOriginal(keyWithBrand)
        let result = ""
        if (brandValue !== keyWithBrand) {
            result = brandValue
            return translationDebugEnabled ? `${result} [${keyWithBrand}]` : result
        }
        result = tOriginal(key, params)
        return translationDebugEnabled && result !== key ? `${result} [${key}]` : result
    }

    const response = [t, i18n, ready] as UseTranslationResponse<'dcc-app'>
    response.t = t
    response.i18n = i18n
    response.ready = ready

    return response
}

export default useTranslation
